import React from 'react';
import TableHeader from './TableHeader';
import QuickStatsTableBody from './QuickStatsTableBody';
import { Table } from 'react-bootstrap';
import classes from '../index.module.scss';

const QuickStatsTableContainer = ({ stats, header_list }) => {
  return (
    <Table striped responsive className={`${classes.Table} mb-4`}>
      <thead className={classes.Table_Head}>
        <TableHeader 
          list={header_list}
        />
      </thead>
      <tbody className={classes.Table_Body}>
        <QuickStatsTableBody list={stats} />
      </tbody>
    </Table>
  )
}

export default QuickStatsTableContainer;